import { SearchPropertyStatus } from '../types';
import {
  SearchModalBudgetFilterMaxPrices,
  SearchModalBudgetFilterMinPrices,
  SearchModalBudgetFilterNonRentalPriceOptions,
  SearchModalBudgetFilterRentalPriceOptions,
} from '../types';

export const getBudgetPriceOptionsByByPropertyStatus = ({
  minPrices,
  maxPrices,
  propertyStatus,
}: {
  minPrices?: SearchModalBudgetFilterMinPrices | null;
  maxPrices?: SearchModalBudgetFilterMaxPrices | null;
  propertyStatus: SearchPropertyStatus;
}): SearchModalBudgetFilterRentalPriceOptions | SearchModalBudgetFilterNonRentalPriceOptions => {
  const nonRentalPriceOptions: SearchModalBudgetFilterNonRentalPriceOptions = {
    minPrices: minPrices?.nonRentalPriceOptions ?? [],
    maxPrices: maxPrices?.nonRentalPriceOptions ?? [],
  };

  const rentalPriceOptions: SearchModalBudgetFilterRentalPriceOptions = {
    minPrices: minPrices?.rentalPriceOptions ?? [],
    maxPrices: maxPrices?.rentalPriceOptions ?? [],
  };

  switch (propertyStatus) {
    case SearchPropertyStatus.forSale:
      return nonRentalPriceOptions;
    case SearchPropertyStatus.forRent:
      return rentalPriceOptions;
    case SearchPropertyStatus.sold:
      return nonRentalPriceOptions;
    default:
      return nonRentalPriceOptions;
  }
};
